import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const CircleError = ({ height = '24px', width = '24px', stroke = 'currentColor', ...rest }) => {
    return (_jsxs(BaseIcon, { width: width, height: height, viewBox: '0 0 24 24', fill: 'none', stroke: stroke, ...rest, children: [_jsx("circle", { cx: '12', cy: '12', r: '7.375', stroke: stroke, strokeWidth: '1.25' }), _jsx("path", { d: 'M7 17.5L17 6.5', stroke: stroke, strokeWidth: '1.25' })] }));
};
//# sourceMappingURL=CircleError.js.map